import attribs from '../../settings/references.json'
import parseImport from '../../markdown/parser'
import { selectors } from '../Settings'

export const attributes = {
    languages: attribs.languages,
}

export const parse = parseImport

export function getLayout(state) {
    return selectors.getLayout(state)
}



// WEBPACK FOOTER //
// ./src/features/Toaster/imports.js